<script>
import CancellationPolicy from "../Policies/CancellationPolicy.vue";
import {mapWritableState} from "pinia";
import {FormDataStore} from "../../stores/FormDataStore";

export default {
  name: "CancellationPolicyQuestion",
  components: {CancellationPolicy},
  computed: {
    ...mapWritableState(FormDataStore, ['formData']),
  },
}
</script>

<template>
  <div id="policyConfirmationQuestion">
    <div class="container mb-1">
      <div class="row">
        <CancellationPolicy />
        <div>
          <label class="checkbox-label">
            <input type="checkbox" v-model="formData.cancellationPolicy.cancellationPolicy"> <span>Tick this box to accept the cancellation policy</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>